import { Component, ElementRef, AfterViewInit, ChangeDetectorRef, ViewChild, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService, AlertService } from '../_services';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { OpentokService } from '../_services/opentok.service';


@Component({
  selector: 'app-intermidiate',
  templateUrl: './intermidiate.component.html',
  styleUrls: ['./intermidiate.component.css']
})
export class IntermidiateComponent implements OnInit {

  publishing: Boolean;
  timershow: string;
  loading = false;
  submitted = false;
  returnUrl: string;
  imagePath: string;
  student_data: any;
  interval;
  settime;
  isPause = false;

  students = [];
  studentName: string
  studentCode: string
  feed: any;
  localData = {};
  authenticationService: any;
  changeDetectorRef: ChangeDetectorRef;
  timesession: string
  isError = false
  errorMsg: string
  private sub: any;
  practical_id: number
  student_id:number



  constructor(private route: ActivatedRoute,
    private router: Router,
    private studentService: StudentService,
    private alertService: AlertService,
    private globals: Globals,
    private opentokService: OpentokService,
    private ref: ChangeDetectorRef,) { this.changeDetectorRef = ref; }



  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.practical_id = +params['id'];
      this.student_id=+params['stdid']
    });
    this.localData = JSON.parse(localStorage.getItem('currentUser'));
    this.returnUrl = '/';
    // this.student_data = JSON.parse(localStorage.getItem('student_data'));
    // this.studentName = this.student_data['name'];
    // this.studentCode = this.student_data['code'];




    this.getStudentsData();
  }

  private getStudentsData() {
    this.studentService.pracStudent(this.globals.root_url, this.localData['usercode'], this.student_id, this.practical_id, this.localData['id'], this.localData['exam_id'])
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            let feed = data.feed
            this.timesession = data.timesession
            let vcsetting = {'s_id':feed.session, 't_id':feed.token, 'nos': data.nos, 'timesession': data.timesession, 'maxmarks': data.maxmarks,'practical_id':data.practical_id,'student_id':data.student_id}
            sessionStorage.setItem('pkshn_vc_settings',JSON.stringify(vcsetting));                   
            this.router.navigateByUrl('/video-con');
          }
          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
          }
          else if (data.code == 1001) {
            this.isError = true;
            this.errorMsg = 'You do not have any Practical Exam. !!';
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      )
  }
}
